import { Component, Input, NgZone } from "@angular/core";

import { ProductPageFacade } from "@hermes/states/product-page";
import { SINGLE_PRODUCT_PAGE, VtoPageType } from "@hermes/states/vto";

import { VtoModalService } from "../services/vto-modal.service";

@Component({
    selector: "h-virtual-try-on-button",
    templateUrl: "./virtual-try-on-button.component.html",
    styleUrls: ["./virtual-try-on-button.component.scss"],
})
export class VirtualTryOnButtonComponent {
    @Input()
    public pageType: VtoPageType = SINGLE_PRODUCT_PAGE;
    @Input()
    public hasTransition: boolean = false;

    constructor(
        public readonly productPageFacade: ProductPageFacade,
        private vtoModalService: VtoModalService,
        private zone: NgZone,
    ) {}

    public async openModal(): Promise<void> {
        await this.vtoModalService.openVtoModal(SINGLE_PRODUCT_PAGE);

        // TODO Remove this when modal 3DS and apple pay have been added
        this.zone.runOutsideAngular(() => {
            const hRootElement =
                document.getElementsByTagName("h-root")[0] || undefined;
            if (hRootElement) {
                hRootElement.removeAttribute("aria-hidden");
            }
        });
    }
}
